import React, { useState } from 'react';
import { Box, Tabs, Tab, Typography, Paper } from '@mui/material';
import DashboardLayout from "../../../layouts/DashboardLayout";

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

export default function TraspasoEquiposPage() {
    const [tab, setTab] = useState(0);

    const handleChange = (event, newValue) => {
        setTab(newValue);
    };

    return (
        <DashboardLayout>
            <Paper sx={{ width: '100%', minHeight: 400, p: 2 }}>
                <Tabs value={tab} onChange={handleChange} aria-label="Traspaso Equipos Tabs">
                    <Tab label="Realizar Traspaso" />
                    <Tab label="Listado de Traspaso" />
                </Tabs>
                <TabPanel value={tab} index={0}>
                    {/* Aquí va el formulario para realizar traspaso */}
                    <Typography variant="h6">Formulario para realizar traspaso</Typography>
                </TabPanel>
                <TabPanel value={tab} index={1}>
                    {/* Aquí va el listado de traspasos */}
                    <Typography variant="h6">Listado de traspasos</Typography>
                </TabPanel>
            </Paper>
        </DashboardLayout>
    );
}